import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "user-new",
  components: {
    AppHeader
  },
  created() {
    this.getTodayDate();
    this.getCompany();
  },
  data() {
    return {
      user: {
        last_name: "",
        first_name: "",
        last_name_kana: "",
        first_name_kana: "",
        login_id: "",
        company_id: "",
        department_id: "",
        position_id: "",
        authority: "",
        join_day: "",
        gender: "",
        birth_day: "",
        postal_first: "",
        postal_last: "",
        address: "",
        tel_first: "",
        tel_middle: "",
        tel_last: "",
        sub_tel_first: "",
        sub_tel_middle: "",
        sub_tel_last: "",
        email: "",
        paid_holiday_count: "",
        license_content: "",
        content: "",
        tkc_user_no: "",
        emergency1_last_name: "",
        emergency1_first_name: "",
        emergency1_last_name_kana: "",
        emergency1_first_name_kana: "",
        emergency1_postal_first: "",
        emergency1_postal_last: "",
        emergency1_address: "",
        emergency1_tel_first: "",
        emergency1_tel_middle: "",
        emergency1_tel_last: "",
        emergency1_sub_tel_first: "",
        emergency1_sub_tel_middle: "",
        emergency1_sub_tel_last: "",
        emergency1_relationship: "",
        emergency2_last_name: "",
        emergency2_first_name: "",
        emergency2_last_name_kana: "",
        emergency2_first_name_kana: "",
        emergency2_postal_first: "",
        emergency2_postal_last: "",
        emergency2_address: "",
        emergency2_tel_first: "",
        emergency2_tel_middle: "",
        emergency2_tel_last: "",
        emergency2_sub_tel_first: "",
        emergency2_sub_tel_middle: "",
        emergency2_sub_tel_last: "",
        emergency2_relationship: "",
        password: ""
      },
      companies: "",
      positions: "",
      departments: "",
      getCompanisEnd: false,
      getDepartmentsEnd: false,
      getPositionsEnd: false,
      joinYear: "",
      joinMonth: "",
      joinDay: "",
      dayCount: "",
      canChoiceYears: [],
      birthYear: "",
      birthMonth: "",
      birthDay: "",
      birthDayCount: "",
      canChoiceBirthYears: [],
      savingFlag: false
    };
  },
  computed: {
    joinDayFormat() {
      return this.joinYear + "-" + this.joinMonth + "-" + this.joinDay;
    },
    birthDayFormat() {
      return this.birthYear + "-" + this.birthMonth + "-" + this.birthDay;
    },
    isJoinDayBefore() {
      if (this.joinYear && this.joinMonth && this.joinDay) {
        if (
          dayjs(`${this.joinYear}-${this.joinMonth}-${this.joinDay}`).format(
            "YYYY-MM-DD"
          ) <= dayjs().format("YYYY-MM-DD")
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  },
  methods: {
    getTodayDate() {
      let today = new Date();
      this.currentYear = today.getFullYear();
      for (let i = 0; i < 70; i++) {
        this.canChoiceBirthYears.push(this.currentYear - i);
      }
      for (let i = 0; i < 2; i++) {
        this.canChoiceYears.push(this.currentYear - i);
      }
      let calcMonth = today.getMonth() + 1;
      let calcDay = today.getDate();
      this.dayCount = new Date(calcMonth, calcDay, 0).getDate();
      this.birthDayCount = new Date(calcMonth, calcDay, 0).getDate();
    },
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    },
    changeCompany() {
      this.user.department_id = "";
      this.user.position_id = "";
      this.user.authority = "";
      this.getDepartment();
      this.getPosition();
    },
    changePosition() {
      let findPosition = this.positions.find(
        position => position.id == this.user.position_id
      );
      this.user.authority = findPosition.default_authority;
    },
    async getDepartment() {
      let data = {
        company_id: this.user.company_id
      };
      let res = await this.$store
        .dispatch("GET_DEPARTMENT", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.departments = res.departments;
      this.getDepartmentsEnd = true;
    },
    async getPosition() {
      this.getPositionsEnd = false;
      let data = {
        company_id: this.user.company_id
      };
      let res = await this.$store
        .dispatch("GET_POSITION", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.positions = res.positions;
      this.getPositionsEnd = true;
    },
    async createUser() {
      if (this.savingFlag) return;
      this.savingFlag = true;

      this.user.join_day = this.joinDayFormat;
      this.user.birth_day = this.birthDayFormat;
      this.user.password =
        this.birthYear +
        ("0" + this.birthMonth).slice(-2) +
        ("0" + this.birthDay).slice(-2);
      let data = this.user;
      let res = await this.$store
        .dispatch("CREATE_USER", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.$router.push({ path: "/user" });
      }
    },
    getDayCount() {
      this.joinDay = "";
      this.dayCount = new Date(this.joinYear, this.joinMonth, 0).getDate();
    },
    getBirthDayCount() {
      this.birthDay = "";
      this.birthDayCount = new Date(
        this.birthYear,
        this.birthMonth,
        0
      ).getDate();
    },
    goUser() {
      this.$router.push({ path: "/user" });
    }
  }
};
